<script>
import { listenToProjection } from '@trullock/firebase-client';
import UserView from '../../../functions/domain/users/userView.js';
import { getCurrentUserId } from '../../js/auth.js';

export const pageName = 'tools';
export const pageRoute = '/tools';
export const title = 'Tools'

export default {
	data() {
		return { 
			showMemberTools: false
		}
	},

	methods: {
		
		async boot(opts) {
			await listenToProjection([UserView, getCurrentUserId()], async user => {
				this.showMemberTools = user.isVendor || user.isAdmin;
			});
		}
	}
}

</script>
<template>
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-12 col-md-6 my-5">
				<h1 class="display-4 text-center mb-3">Tools</h1>
				<p class="text-muted text-center mb-5">What are you stuck with?</p>
			</div>
			<div class="col-12 col-md-10 mb-4">
				<h2>Ground Support</h2>
				<div class="row">
					<div class="col-12 col-md-6 col-lg-4">
						<div class="card">
							<div class="card-header">
								<h4 class="card-header-title">Rocket Tracker</h4>
								<span class="badge badge-danger">Beta</span>
							</div>
							<div class="card-body">
								<p>Collaboratively track the landing site for your rockets</p>
								<a href="/tools/tracker" class="btn btn-primary btn-block">Tracker <span class="fe fe-arrow-right-circle"></span></a>
							</div>
						</div>
					</div>
					<div class="col-12 col-md-6 col-lg-4">
						<div class="card">
							<div class="card-header">
								<h4 class="card-header-title">Launch Site Finder</h4>
							</div>
							<div class="card-body">
								<p>Locate a suitable flying site with minimum dimensions.</p>
								<a href="/tools/launch-sites" class="btn btn-primary btn-block">Launch Sites <span class="fe fe-arrow-right-circle"></span></a>
							</div>
						</div>
					</div>
					<div class="col-12 col-md-6 col-lg-4">
						<div class="card">
							<div class="card-header">
								<h4 ccol-4lass="card-header-title">NOTAM List</h4>
							</div>
							<div class="card-body">
								<p>See a list of current and upcoming rocketry related NOTAMS</p>
								<a href="/tools/notam-list" class="btn btn-primary btn-block">NOTAM List <span class="fe fe-arrow-right-circle"></span></a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-10">
				<h2>Calculators</h2>
				<div class="row">
					<div class="col-12 col-md-6 col-lg-4">
						<div class="card">
							<div class="card-header">
								<h4 class="card-header-title">Barometer vent holes</h4>
							</div>
							<div class="card-body">
								<p>Calculate the size and number of required vent holes for barometer based flight computers.</p>
								<a href="/tools/vent-holes" class="btn btn-primary btn-block">Vent holes <span class="fe fe-arrow-right-circle"></span></a>
							</div>
						</div>
					</div>
					<div class="col-12 col-md-6 col-lg-4">
						<div class="card">
							<div class="card-header">
								<h4 class="card-header-title">Ejection charge</h4>
							</div>
							<div class="card-body">
								<p>Calculate the amount of FFFFg black powder to use with ejection charges.</p>
								<a href="/tools/ejection-charge" class="btn btn-primary btn-block">Ejection charge <span class="fe fe-arrow-right-circle"></span></a>
							</div>
						</div>
					</div>
					<div class="col-12 col-md-6 col-lg-4">
						<div class="card">
							<div class="card-header">
								<h4 class="card-header-title">Parachute Size</h4>
							</div>
							<div class="card-body">
								<p>Calculate the size parachute you need for a given weight and descent speed.</p>
								<a href="/tools/parachute-calculator" class="btn btn-primary btn-block">Parachute <span class="fe fe-arrow-right-circle"></span></a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="showMemberTools" class="col-12 col-md-10">
				<h2>Members</h2>
				<div class="row">
					<div class="col-12 col-md-6 col-lg-4">
						<div class="card">
							<div class="card-header">
								<h4 class="card-header-title">RSO/FCO List</h4>
							</div>
							<div class="card-body">
								<p>List all current RSO/FCOs</p>
								<a href="/tools/rsos" class="btn btn-primary btn-block">RSO list <span class="fe fe-arrow-right-circle"></span></a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
